import { QueryObserverOptions } from '@tanstack/react-query'

import { buildGetQuery } from '../../util'
import config from '../../config'

type Params = {
  id: number
}

const getSafetyCaseReportRequest = (params: Params): any => {
  const { id } = params

  return {
    method: 'get',
    responseType: 'blob',
    url: `${config.baseUrl}/sms/SafetyCases/${id}/Report`,
  }
}

const useSafetyCasesReportQueryBase = buildGetQuery<Params, undefined, Blob | string | undefined>({
  getRequest: getSafetyCaseReportRequest,
  getQueryKey: params => ['safety-case-report', params.id],
})

const useSafetyCasesReportQuery = (id: number, options?: QueryObserverOptions<Blob | string | undefined, Error>) =>
  useSafetyCasesReportQueryBase({ id }, undefined, options)

export default useSafetyCasesReportQuery
